'use client';

import { FC } from 'react';
import { FinderMainBannerStoryblok } from 'storyblok-types';
import { Image } from 'atoms/Image/Image';
import { H1, P } from 'atoms/Typography';
import { useMediaQuery } from 'modules/mui/hooks';
import styles from './styles.module.css';

export const FinderMainBanner: FC<{ blok: FinderMainBannerStoryblok }> = ({
  blok,
}) => {
  const { isTablet } = useMediaQuery();

  return (
    <div className={styles.root}>
      <div
        className={styles.banner}
        style={{ backgroundImage: `url(${blok?.background?.filename})` }}
      >
        {isTablet && blok.image?.filename && (
          <Image
            src={blok.image.filename}
            alt={blok.image?.alt}
            className={styles.mainImage}
          />
        )}

        {(blok.title || blok.subtitle) && (
          <div className={styles.info}>
            {blok.title && <H1 className={styles.title}>{blok.title}</H1>}
            {blok.subtitle && (
              <P className={styles.subtitle}>{blok.subtitle}</P>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
